import { Capacitor } from '@capacitor/core';
import {StorageService} from "@/services/storageService.ts";

export const isNative = Capacitor.isNativePlatform();
export const platform = Capacitor.getPlatform();

export const getBaseDomain = async (): Promise<string> => {
    if (isNative) {
        return await StorageService.Get<string>("CHAIN_SERVICER_URL");
    } else {
        return window.location.origin;
    }
};

export const getIframeBaseUrl = async (): Promise<string> => {
    const domain = await getBaseDomain();
    // todo remove when delivery iframe exist in head
    // return `http://192.168.1.57`;
    return `${domain}/service`;
};